import React, {Component, Suspense} from "react";
import {connect} from "react-redux";
import {Col, message, Row} from 'antd';
import {get_response} from "../helper/request";

const Plot = React.lazy(() => import("react-plotly.js"));

class LivePlot extends Component {
    constructor(props) {
        super(props);
        this.timer = null;
        this.state = {
            data: null,
            dataPath: this.props.match.params.path
        }
    }

    getPlotData = () => {
        let url = `/server/live_plot/` + this.state.dataPath;
        get_response(url)
            .then(response => {
                if (response.status !== 200) {
                    message.error("Error");
                } else {
                    this.setState({
                        data: response.data
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    };

    doPolling = () => {
        this.getPlotData();
    }

    componentDidMount = () => {
        this.timer = setInterval(this.doPolling, 1000);
    }

    render() {
        return (
            <div id="scanner-div">
                <Row className="rounded-container">
                    <Col className="scanner-name arial-font" span={24}>
                        {"Live Data Plotter"}
                    </Col>
                </Row>
                <Row>
                    <Col offset={1} span={12}>
                        <Suspense fallback={<div>Loading...</div>}>
                            <Plot
                                data={(this.state.data || {}).data}
                                layout={{
                                    height: 840, width: 1580, title: "ZDrop Data Plot " + (this.state.data || {}).msg || "",
                                    xaxis: {
                                        title: {
                                            text: 'Time (Minutes)',
                                            font: {
                                                family: 'Courier New, monospace',
                                                size: 18,
                                                color: '#7f7f7f'
                                            }
                                        }
                                    },
                                    yaxis: {
                                        // range: [-0.1, 1.1],
                                        title: {
                                            text: 'Status',
                                            font: {
                                                family: 'Courier New, monospace',
                                                size: 18,
                                                color: '#7f7f7f'
                                            }
                                        }
                                    }
                                }}
                            />
                        </Suspense>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

export default connect(mapStateToProps)(LivePlot);
